<template>
  <b-container>
    <b-tabs content-class="mt-3" align="center">
      <!--USER INFO-->
      <b-tab title="User Info" active>
        <b-row>
          <b-col cols="12" class="mt-5">
            <h2 class="font-weight-bold">User Info</h2>
            <p class="text-muted">
                Please fill in the information below regarding company and contact
                information
              </p>
          </b-col>
          <b-col cols="12">
              <b-row>
                <b-col cols="12" md="6" class="mt-5">
                  <label>First Name:</label>
                  <b-form-input v-model="user.fname" placeholder="First Name" />
                </b-col>
                <b-col cols="12" md="6" class="mt-5">
                  <label>Last Name:</label>
                  <b-form-input v-model="user.lname" placeholder="Last Name" />
                </b-col>
              </b-row>
            </b-col>
        </b-row>
      </b-tab>
      
      
      
      <!--COMPANY INFO-->
      <b-tab title="Company Info">
        <b-row>
          <b-col cols="12" class="mt-5">
            <h2 class="font-weight-bold">Company Information</h2>
          </b-col>
          <b-col cols="12" class="mt-5">
            <label>Company Name:</label>
            <b-form-input v-model="company.name" placeholder="Company Name" />
          </b-col>
          <b-col cols="12" class="mt-5">
            <label>Address: Use this to autocomplete your address.</label>
            <google-autocomplete
              id="companyAddress"
              class="form-control"
              types="geocode"
              placeholder="Start typing"
              v-model="company.address.formatted"
              v-on:placechanged="getAddressData"
              v-if="company.address != null"
            />
          </b-col>
          <b-col cols="12" class="mt-5">
            <p>Please review the data below and ensure it is correct.</p>
          </b-col>
          <b-col cols="12" md="6" class="mt-3">
            <label>Line 1:</label>
            <b-form-input v-model="company.address.line1" placeholder="123 Playground Street" />
          </b-col>
          <b-col cols="12" md="6" class="mt-3">
            <label>Line 2:</label>
            <b-form-input v-model="company.address.line2" placeholder="101, E, etc..." />
          </b-col>
          <b-col cols="12" md="6" class="mt-5">
            <label>City:</label>
            <b-form-input v-model="company.address.city" placeholder="San Francisco" />
          </b-col>
          <b-col cols="12" md="6" class="mt-5">
            <label>Province/State:</label>
            <b-form-select
              :options="company.address.country === 'CA' || company.address.country === 'Canada'? provinces : states"
              v-model="company.address.state"
            >
              <b-form-select-option value>Please select a country to populate the list</b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="12" md="6" class="mt-5">
            <label>Postal/Zip Code:</label>
            <b-form-input v-model="company.address.postal_code" placeholder="L0L 0L0 or 12345" />
          </b-col>
          <b-col cols="12" md="6" class="mt-5">
            <label>Country:</label>
            <b-form-input v-model="company.address.country" placeholder="Canada, United States, etc..." />
          </b-col>
        </b-row>  
      </b-tab>
    </b-tabs>
    <b-col cols="12" class="mt-5">
      <b-button size="lg" variant="primary" @click="updateCompany">Save</b-button>
    </b-col>
  </b-container>
</template>
<script>
import GoogleAutocomplete from "vue-google-autocomplete";
import Company from "@/fstore/collections/Company";
import User from "@/fstore/collections/User";
import regions from "@/misc/regions";
export default {
  components: {
    GoogleAutocomplete
  },
  data() {
    return {
      company: this.$store.state.company.data,
      user: this.$store.state.auth.data,
      provinces: regions.provinces,
      states: regions.states
    };
  },
  methods: {
    async updateCompany() {
      this.$store.dispatch("app/setOverlay", true);
      await this.$store.dispatch('auth/update', this.user);
      await Company.update(this.company.uid, this.company);
      this.$store.dispatch("app/setOverlay", false);

      this.$store.dispatch("app/setAlert", {
        type: "success",
        message: 'information updated successfully.'
      }); //end dispatch alert

      this.$emit('changeTab', 'dashboard');

    },
    getAddressData(address) {
      let formatted_address = "";

      if (!this.company.address) this.company.address = {};

      this.company.address.line1 = `${address.street_number} ${address.route}`;

      if (typeof address.street_number !== "undefined")
        formatted_address += `${address.street_number} `;

      if (typeof address.route !== "undefined")
        formatted_address += `${address.route}, `;

      if (typeof address.locality !== "undefined") {
        this.company.address.city = address.locality;
        formatted_address += `${address.locality}, `;
      }

      if (typeof address.administrative_area_level_1 !== "undefined") {
        this.company.address.state = address.administrative_area_level_1;
        formatted_address += `${address.administrative_area_level_1}, `;
      }

      if (typeof address.country !== "undefined") {
        formatted_address += `${address.country}`;
        this.company.address.country = address.country;
      }

      this.company.address.postal_code = address.postal_code;

      this.company.address.formatted = formatted_address;
    }
  }
};
</script>
